import React from 'react';
import { Facebook, Instagram, Mail, Phone, MapPin, MessageCircle } from 'lucide-react';
import { Button } from './ui/Button';
export function Footer() {
  return <footer className="bg-atomic-black border-t border-white/10" data-id="element-85">
      {/* Contact Action Band */}
      <div className="py-10 border-b border-white/10" data-id="element-86">
        <div className="container mx-auto px-4 md:px-6" data-id="element-87">
          <div className="max-w-3xl mx-auto text-center" data-id="element-88">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-89">
              Ready to get started?
            </h3>
            <p className="text-gray-400 mb-6" data-id="element-90">
              Text us, message us on Facebook, or give us a call — we typically
              respond within minutes.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3" data-id="element-91">
              {/* Text Us */}
              <a href="sms:+15174149232" className="w-full sm:w-auto" data-id="element-92">
                <Button size="lg" className="w-full sm:w-auto gap-2" data-id="element-93">
                  <MessageCircle className="w-5 h-5" data-id="element-94" />
                  Text Us
                </Button>
              </a>

              {/* Facebook Message */}
              <a href="https://m.me/atomicMI" target="_blank" rel="noopener noreferrer" title="Facebook Message" aria-label="Facebook Message" className="w-full sm:w-auto" data-id="element-95">
                <Button variant="outline" size="lg" className="w-full sm:w-auto gap-2" data-id="element-96">
                  <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current" aria-hidden="true" data-id="element-97">
                    <path d="M12 2C6.36 2 2 6.13 2 11.7c0 2.91 1.2 5.42 3.15 7.2V22l2.95-1.62c.84.23 1.72.36 2.65.36h.25c5.64 0 9.75-4.13 9.75-9.66C20.75 6.13 17.64 2 12 2zm1.08 13.02l-2.5-2.67-4.87 2.67 5.36-5.69 2.56 2.67 4.81-2.67-5.36 5.69z" data-id="element-98" />
                  </svg>
                  Facebook Message
                </Button>
              </a>

              {/* Call */}
              <a href="tel:+15174149232" className="w-full sm:w-auto" data-id="element-99">
                <Button variant="ghost" size="lg" className="w-full sm:w-auto gap-2" data-id="element-100">
                  <Phone className="w-5 h-5" data-id="element-101" />
                  Call 517-414-9232
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Columns */}
      <div className="pt-16 pb-10" data-id="element-102">
        <div className="container mx-auto px-4 md:px-6" data-id="element-103">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-104">
            {/* Brand */}
            <div data-id="element-105">
              <a href="/" className="flex items-center gap-3 mb-6" data-id="element-106">
                <img src="https://cdn.magicpatterns.com/uploads/nTH6rvmmBYe1TvsMQVLcBV/Atomic_Logo.png" alt="Print Atomic Logo" className="h-10 w-auto" data-id="element-107" />
              </a>
              <p className="text-gray-400 mb-6" data-id="element-108">
                A trusted partner for custom apparel and nationwide DTF printing
                and shipping. Proudly based in Morrice, Michigan and serving
                customers across the United States.
              </p>
              <div className="flex gap-4" data-id="element-109">
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-atomic-charcoal flex items-center justify-center text-gray-400 hover:bg-atomic-green hover:text-black transition-colors" data-id="element-110">
                  <Instagram size={20} data-id="element-111" />
                </a>
                <a href="https://www.facebook.com/atomicMI" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-atomic-charcoal flex items-center justify-center text-gray-400 hover:bg-atomic-green hover:text-black transition-colors" data-id="element-112">
                  <Facebook size={20} data-id="element-113" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div data-id="element-114">
              <h4 className="text-white font-bold mb-6" data-id="element-115">Services</h4>
              <ul className="space-y-4" data-id="element-116">
                <li data-id="element-117">
                  <a href="/dtf-printing" className="text-gray-400 hover:text-atomic-green transition-colors" data-id="element-118">
                    DTF Transfers
                  </a>
                </li>
                <li data-id="element-119">
                  <a href="/screen-printing" className="text-gray-400 hover:text-atomic-green transition-colors" data-id="element-120">
                    Screen Printing
                  </a>
                </li>
                <li data-id="element-121">
                  <a href="/custom-apparel" className="text-gray-400 hover:text-atomic-green transition-colors" data-id="element-122">
                    Custom Apparel
                  </a>
                </li>
                <li data-id="element-123">
                  <a href="/custom-banners" className="text-gray-400 hover:text-atomic-green transition-colors" data-id="element-124">
                    Custom Banners
                  </a>
                </li>
                <li data-id="element-125">
                  <a href="/business-cards" className="text-gray-400 hover:text-atomic-green transition-colors" data-id="element-126">
                    Business Cards
                  </a>
                </li>
                <li data-id="element-127">
                  <a href="/custom-key-tags" className="text-gray-400 hover:text-atomic-green transition-colors" data-id="element-128">
                    Custom Key Tags
                  </a>
                </li>
              </ul>
            </div>

            {/* Company */}
            <div data-id="element-129">
              <h4 className="text-white font-bold mb-6" data-id="element-130">Company</h4>
              <ul className="space-y-4" data-id="element-131">
                <li data-id="element-132">
                  <a href="/about" className="text-gray-400 hover:text-atomic-green transition-colors" data-id="element-133">
                    About Us
                  </a>
                </li>
                <li data-id="element-134">
                  <a href="/catalog" className="text-gray-400 hover:text-atomic-green transition-colors" data-id="element-135">
                    Catalog
                  </a>
                </li>
                <li data-id="element-136">
                  <a href="/faq" className="text-gray-400 hover:text-atomic-green transition-colors" data-id="element-137">
                    FAQ
                  </a>
                </li>
                <li data-id="element-138">
                  <a href="/contact" className="text-gray-400 hover:text-atomic-green transition-colors" data-id="element-139">
                    Contact / Get a Quote
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div data-id="element-140">
              <h4 className="text-white font-bold mb-6" data-id="element-141">Contact</h4>
              <ul className="space-y-4" data-id="element-142">
                <li className="flex items-start gap-3 text-gray-400" data-id="element-143">
                  <MapPin className="text-atomic-green shrink-0 mt-1" size={20} data-id="element-144" />
                  <span data-id="element-145">
                    320 Main Street
                    <br data-id="element-146" />
                    Morrice, MI 48857
                  </span>
                </li>
                <li className="flex items-center gap-3 text-gray-400" data-id="element-147">
                  <Phone className="text-atomic-green shrink-0" size={20} data-id="element-148" />
                  <a href="tel:+15174149232" className="hover:text-atomic-green transition-colors" data-id="element-149">
                    517-414-9232
                  </a>
                </li>
                <li className="flex items-center gap-3 text-gray-400" data-id="element-150">
                  <MessageCircle className="text-atomic-green shrink-0" size={20} data-id="element-151" />
                  <a href="sms:+15174149232" className="hover:text-atomic-green transition-colors" data-id="element-152">
                    Text Us
                  </a>
                </li>
                <li className="flex items-center gap-3 text-gray-400" data-id="element-153">
                  <Mail className="text-atomic-green shrink-0" size={20} data-id="element-154" />
                  <a href="mailto:info@printatomic.com" className="hover:text-atomic-green transition-colors" data-id="element-155">
                    info@printatomic.com
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="pt-8 border-t border-white/10 text-center" data-id="element-156">
            <p className="text-gray-500 text-sm" data-id="element-157">
              © {new Date().getFullYear()} Print Atomic. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}